import React, { Component } from 'react'
import { withPrefix } from 'gatsby'

class Card extends Component {
    render() {
        const { post, url = false, click = false } = this.props

        const {
            feature_image,
            excerpt,
            title,
            primary_author,
            published_at_pretty,
        } = post

        return (
            <>
                <header
                    className="post-card-header"
                    onClick={() => {
                        click && click(url)
                    }}
                >
                    {feature_image && (
                        <div
                            className="post-card-image"
                            style={{
                                backgroundImage: `url(${feature_image})`,
                            }}
                        />
                    )}
                </header>
                <footer>
                    <div className="hover">
                        <h1
                            className="overflow"
                            onClick={() => {
                                click && click(url)
                            }}
                        >
                            {title}
                        </h1>
                        <p className="overflow">{excerpt}</p>
                        <p>&nbsp;</p>
                        <p>
                            By{' '}
                            <a
                                href={withPrefix(
                                    `/author/${post.primary_author.slug}`
                                )}
                            >
                                {primary_author.name}
                            </a>{' '}
                            &mdash; {published_at_pretty}
                        </p>
                    </div>
                </footer>
            </>
        )
    }
}

export default Card
